// extracted by mini-css-extract-plugin
export default {"input_group":"ProfileInput_input_group__MrS-q","input":"ProfileInput_input__3xIzo","label":"ProfileInput_label__bTsax"};